import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-spinner-animated/dist/index.css'
import { store } from "./redux/store/store";
import { Provider } from "react-redux";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 <React.StrictMode>
     <Provider store={store}>
    <App />
  </Provider>
  </React.StrictMode>
);
